var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{attrs:{"icon":"fullscreen","shape":"circle","size":"small"},on:{"click":_vm.fullScreen}})
}
var staticRenderFns = []

export { render, staticRenderFns }